/**
 * Airtable 아이콘 SVG
 *
 * 크기 조절: className으로 w-*, h-* 클래스 사용
 * @example
 * ```tsx
 * <AirtableIcon className="w-8 h-8" />
 * <AirtableIcon className="w-12 h-12" />
 * ```
 */
export function AirtableIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-label="Airtable icon"
      role="img"
    >
      <title>Airtable</title>
      <g id="Airtable">
        <g id="Vector">
          <path
            d="M14.5029 4.30284L4.06377 8.72872C3.48325 8.97489 3.48926 9.81975 4.07342 10.057L14.5562 14.3163C15.4774 14.6906 16.5031 14.6906 17.424 14.3163L27.907 10.057C28.491 9.81975 28.4972 8.97489 27.9165 8.72872L17.4775 4.30284C16.5251 3.89905 15.4552 3.89905 14.5029 4.30284Z"
            fill="#FFBF00"
          />
          <path
            d="M16.9202 16.6423V27.2827C16.9202 27.7888 17.4182 28.1353 17.8774 27.9489L29.5584 23.3032C29.8251 23.1949 30 22.9309 30 22.6371V11.9967C30 11.4906 29.5019 11.144 29.0428 11.3305L17.3617 15.9761C17.0952 16.0844 16.9202 16.3484 16.9202 16.6423Z"
            fill="#26B5F8"
          />
          <path
            d="M14.1926 17.1913L10.7259 18.9063L10.3739 19.0806L3.05596 22.6733C2.59208 22.9026 2 22.5563 2 22.0283V12.0414C2 11.8503 2.09559 11.6854 2.22379 11.5612C2.27728 11.5062 2.3379 11.461 2.40089 11.4251C2.57578 11.3176 2.8252 11.2889 3.03728 11.3749L14.1343 15.8799C14.6984 16.1092 14.7427 16.919 14.1926 17.1913Z"
            fill="#ED3049"
          />
        </g>
      </g>
    </svg>
  );
}
